<template>
  <div class="page">
    <div class="page-content">
			<page-nav-bar currentServiceName="MoneyRoad" :subNavTitle="changePassword_title" :closePage="isSmartphone"></page-nav-bar>
      <div class="layoutTop"/>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-10 offset-md-1">
      <div class="panel21 panel-default">

        <div class="panel-heading">
            <h4 class="content-block labelAccordionForm">
                <f7-icon f7="gear"></f7-icon>
                {{ $t('common.chg_pwd') }}
            </h4>
        </div>

        <form>
          <div class="form-group row">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.idtfr') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" type="text" v-model="login" disabled>
              </input>
            </div>
          </div>
          <div v-if="!connectToGoogle" class="form-group row">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.orig_pwd') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="changePassword_OriginalPassword" type="password" v-model="originalPassword"></input>
            </div>
          </div>
          <div class="form-group row">
            <label v-if="connectToGoogle" class="col-4 col-sm-2 col-form-label">{{ $t('common.pwd') }}</label>
            <label v-else class="col-4 col-sm-2 col-form-label">{{ $t('common.new_pwd') }}</label>
            <div class="col-8 col-sm-10">
              <input v-if="connectToGoogle" class="form-control" :placeholder="changePassword_Password" type="password" v-model="newPassword"></input>
              <input v-else class="form-control" :placeholder="changePassword_NewPassword" type="password" v-model="newPassword"></input>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.conf_pwd') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="changePassword_ConfirmPassword" type="password" v-model="confirmNewPassword"></input>
            </div>
          </div>
          <div v-if="connectToGoogle" class="form-group row">
            <div class="text-right col-sm-12 small font-italic">{{ $t('profilesPage.ggl_check_pwd') }}</div>
          </div>
        </form>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 offset-md-9" v-bind:class="colorBottomButton">
    	   <button round :title="changePassword_Validatechanges" class="button-action firstButtonMarginTop" @click="changePassword">
           <i class="icon fa fa-save"></i>
           <span>{{ $t('common.sve') }}</span>
         </button>
       </div>
    </div>
  </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      login: '',
      originalPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      connectToGoogle: false
    }
  },
  created () {
    this.changePassword_title = this.$i18n.t('common.chg_pwd')
    this.changePassword_OriginalPassword = this.$i18n.t('common.orig_pwd')
    this.changePassword_Password = this.$i18n.t('common.pwd')
    this.changePassword_NewPassword = this.$i18n.t('common.new_pwd')
    this.changePassword_ConfirmPassword = this.$i18n.t('common.conf_pwd')
    this.changePassword_Validatechanges = this.$i18n.t('common.valid_chgs')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.login = this.$engine.user.getLogin()
  },
  mounted () {
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.connectToGoogle = true
    } else {
      this.connectToGoogle = false
    }
  },
  methods: {
    changePasswordAPI (connectBy) {
      let that = this
      this.$engine.user.changePassword({
        originalPassword: this.originalPassword,
        newPassword: this.newPassword,
        'connectBy': connectBy
      })
      .then(response => {
        if (response.status === 200) {
          this.$engine.user.connectBy = 'login-password-capi'
          that.$f7.modal({
            title: 'Password modified',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/profile/', force: false, ignoreCache: false})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    changePassword () {
      let that = this
      if (that.newPassword !== that.confirmNewPassword) {
        that.$f7.alert('Passwords do not match', 'Error')
      } else if (that.originalPassword === '' && this.$engine.user.connectBy !== 'vue-google-oauth2') {
        that.$f7.alert('Original password missing', 'Error')
      } else if (that.newPassword === '') {
        that.$f7.alert('New password missing', 'Error')
      } else if (that.confirmNewPassword === '') {
        that.$f7.alert('Please confirm password', 'Error')
      } else {
        var connectBy = 'lpc'
        if (this.$engine.user.connectBy === 'vue-google-oauth2') {
          connectBy = 'vgo'
          // On se conecte via Google
          this.$gAuth.signIn()
          .then(GoogleUser => {
            this.changePasswordAPI(connectBy)
          })
          .catch(error => {
            errorMessageAlert(error, this)
          })
        } else {
          this.changePasswordAPI(connectBy)
        }
      }
    }
  }
}
</script>
<style scoped>

.container {
    /* margin-right: auto;
    margin-left: auto; */
    width: 100%;
    height: auto;
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

 .col-md-12 {
    float: right;
    width: 100%;
    height: 100%;
    padding: 0px;
}
.col-md-4 {
  float: left;
  width: 100%;
  margin: 0px;
}
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}
</style>



// WEBPACK FOOTER //
// CMChangePassword.vue?5a73c404